import React, { useEffect, useState, useMemo } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useTable, usePagination, useGlobalFilter, useSortBy } from "react-table";
import Swal from "sweetalert2";
import { SERVER_BASE } from '../config/server';
import "bootstrap/dist/css/bootstrap.min.css";
import apiClient from "../utils/apiClient";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronCircleLeft, faEdit, faEllipsisV, faPen, faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";

import moment from "moment";

const VehicleMasterList = ({ permissions }) => {
    const [vehicleData, setVehicleData] = useState([]);
    const [loadingData, setLoading] = useState(true);
    const role = localStorage.getItem('role');
    const navigate = useNavigate();
    useEffect(() => {
        fetchVehicleDetails();
    }, []);

    const fetchVehicleDetails = async () => {
        try {
            const response = await apiClient.get(`${SERVER_BASE}/getVehicleDetailsListing`);
            setVehicleData(response.data);
            setLoading(false);
        } catch (error) {
            console.error("Error fetching ledger:", error);
            setLoading(false);
        }
    };

    const handleEdit = (row) => {
        navigate(`../VehicleMaster`, { state: { row } });
    };
    const handleDelete = async (id) => {
        const confirmResult = await Swal.fire({
            title: "Are you sure?",
            text: "This vehicle will be permanently deleted.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, delete it",
            cancelButtonText: "Cancel",
        });

        if (!confirmResult.isConfirmed) return;

        try {
            await apiClient.delete(`${SERVER_BASE}/deleteVehicle/${id}`)

            Swal.fire({
                toast: true,
                icon: "success",
                title: "Conversion deleted vehicle",
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
            });

            fetchVehicleDetails(); // Refresh list after deletion
        } catch (error) {
            console.error("Error deleting vehicle:", error);
            Swal.fire({
                toast: true,
                icon: "error",
                title: "Error deleting vehicle",
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
            });
        }
    };


    const columns = useMemo(
        () => [
            {
                Header: 'S.No',
                Cell: ({ row }) => row.index + 1,
            },
            { Header: "Vehcile No", accessor: (row) => row.vehicleNo || "-" },
            { Header: "Type", accessor: (row) => row.vehicleType || "-" },
            { Header: "Total Capicity", accessor: (row) => row.capacity || "-" },
            { Header: "Policy End Date", accessor: (row) => row.endDate, Cell: ({ value }) => value ? moment(value).format("DD-MMM-YY") : "-" },
            { Header: "Fitness Certificate End Date", accessor: (row) => row.fitnessCertificateEndDate, Cell: ({ value }) => value ? moment(value).format("DD-MMM-YY") : "-" },
            {
                Header: "#",
                accessor: "actions",
                Cell: ({ row }) => {
                    return (
                        <div className="dropdown">
                            <button
                                className="btn btn-light btn-sm"
                                type="button"
                                id={`dropdownMenuButton-${row.index}`}
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                            >
                                <FontAwesomeIcon icon={faEllipsisV} />
                            </button>

                            <ul
                                className="dropdown-menu dropdown-menu-end"
                                aria-labelledby={`dropdownMenuButton-${row.index}`}
                            >
                                {/* Edit */}
                                {(permissions?.edit || role == 'itManager') && (
                                    <li>
                                        <button
                                            className="dropdown-item"
                                            onClick={() => handleEdit(row.original)}
                                        >
                                            <FontAwesomeIcon icon={faEdit} /> Edit
                                        </button>
                                    </li>
                                )}
                                {(permissions?.delete || role == 'itManager') && (
                                    <li>
                                        <button
                                            className="dropdown-item"
                                            onClick={() => handleDelete(row.original.id)}
                                        >
                                            <FontAwesomeIcon icon={faTrash} /> Delete
                                        </button>
                                    </li>
                                )}
                            </ul>
                        </div>
                    );
                }
            }
        ],
        [permissions]
    );

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        page,
        prepareRow,
        setGlobalFilter,
        nextPage,
        previousPage,
        canNextPage,
        canPreviousPage,
        state: { globalFilter, pageIndex },
    } = useTable(
        { columns, data: vehicleData, initialState: { pageSize: 10 } },
        useGlobalFilter,
        useSortBy,
        usePagination
    );

    return (
        <div className="formcontainer mt-5">
            <h3 className="mb-3">Vehicle List</h3>
            <div className="d-flex">
                {(permissions?.write || role == 'itManager') && (
                    <div className="w-25">
                        <button
                            className="btn btn-outline-success"
                            onClick={() => navigate("../VehicleMaster")}
                        >
                            Add Vehicle
                        </button>
                    </div>)}
                <div className="w-100">
                    <input
                        type="text"
                        className="form-control mb-3 "
                        placeholder="Search ledger..."
                        value={globalFilter || ""}
                        onChange={(e) => setGlobalFilter(e.target.value)}
                    />
                </div>
            </div>
            {loadingData ? (
                <p>Loading...</p>
            ) : (
                <div className='table-responsive'>
                    <table {...getTableProps()} className="table table-striped">
                        <thead>
                            {headerGroups.map((headerGroup) => (
                                <tr {...headerGroup.getHeaderGroupProps()}>
                                    {headerGroup.headers.map((column) => (
                                        <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                                            {column.render("Header")} {column.isSorted ? (column.isSortedDesc ? " 🔽" : " 🔼") : ""}
                                        </th>
                                    ))}
                                </tr>
                            ))}
                        </thead>
                        <tbody {...getTableBodyProps()}>
                            {page.map((row) => {
                                prepareRow(row);
                                return (
                                    <tr {...row.getRowProps()}>
                                        {row.cells.map((cell) => (
                                            <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                                        ))}
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            )}
            <div className="d-flex justify-content-between">
                <button className="btn btn-secondary" onClick={previousPage} disabled={!canPreviousPage}>
                    Previous
                </button>
                <span>Page {pageIndex + 1}</span>
                <button className="btn btn-secondary" onClick={nextPage} disabled={!canNextPage}>
                    Next
                </button>
            </div>
        </div>
    );
};

export default VehicleMasterList;